import { render, staticRenderFns } from "./ResearchReport.vue?vue&type=template&id=7b75b704&scoped=true"
import script from "./ResearchReport.vue?vue&type=script&lang=js"
export * from "./ResearchReport.vue?vue&type=script&lang=js"
import style0 from "./ResearchReport.vue?vue&type=style&index=0&id=7b75b704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b75b704",
  null
  
)

export default component.exports